module.exports = __webpack_public_path__ + "static/media/PdapLogoFront.1087daf7.png";